import React from "react"
import styled from "styled-components"
import {Tokens, Container, ButtonLink, SlideIn, FadeIn, AnimationText} from "../components/DesignSystem"
import IntroMessage from "./IntroMessage";
const IntroWrapper = styled.header`
    /* background: var(--darkBlue);
    color: var(--white); */
    padding: var(--stackSpacingXL) 0 var(--stackSpacingXL) 0;
    /* border-radius: 0 0 4rem 4rem; */
    ${Container} {
        position: relative;
        z-index: 4;
    }
    @media ${Tokens.md} {
        height: auto;
        padding: 2rem 0 4rem 0;
    }
`;

const Name = styled.h2`
    font-size: var(--fontSizeXL);
    font-weight: normal;
    margin-bottom: 1rem;
`;

const IntroSentence = styled.div`
    font-size: var(--fontSizeXXXL);
    margin-bottom: 2rem;
    line-height: 1.2;
    font-weight: var(--extraBold);
`;



const introRender = (introVerbiage, totalDelay, messages) => {
    let n = 0;
    return introVerbiage.split('|').map((sen, iS) => {
        return (
            <div key={iS}>
           
                {sen.split(' ').map((word, iW) => {
                    // if it is a trigger
                    let reg = /"(.*)"/g;
                    let tr = reg.exec(word);
                    if(tr) {
                        return (
                            <IntroMessage key={tr[1]} trigger={tr[1]} message={messages[tr[1]]}>
                            {tr[1].split('_').map((realWord) => {
                                n++;
                                return (
                                    <React.Fragment key={n}><AnimationText duration={0.4} delay={totalDelay + 0.1*n}>{realWord}</AnimationText> </React.Fragment>
                                )
                            })}
                            </IntroMessage>
                        );
                        
                    } else {
                        n++;
                        return (
                            <React.Fragment key={n}><AnimationText duration={0.5} delay={totalDelay + 0.07*n}>{word}</AnimationText> </React.Fragment>
                        )
                    }
                    
                })}
          
            
            </div>
        )
    });
}

const Intro = React.memo((props) => {
    // const [introRef, introInView] = useInView({
    //     triggerOnce: true,
    // });
    // useEffect(() => {
    //     if (introInView === true) {
    //         setWasOnceVisible(true);
    //     } 
    // }, [introInView]);
    const messages = {
        product_designer: <>I’d graduated from design school <span rel="image">🎨</span> focusing on <strong>Interaction Design</strong></>,
        codes: <>Yes, I’ve learned to code since secondary school. This portfolio is created on my own using <strong>ReactJS</strong> <span rel="image">🔥</span></>,
        internetrovert: <>Hmm, I spend a lot of time on the Internet, you can stalk me via:<br /><a id="facebook" href="https://www.facebook.com/auduongtuan" target="__blank">Facebook</a> <a href="https://www.instagram.com/auduongtuan" target="__blank" id="instagram">Instagram</a> <a href="https://www.linkedin.com/in/auduongtuan/" target="__blank" id="linkedin">Linkedin</a></>
    }
    const introVerbiage = `I'm an "internetrovert"|"product_designer"|who "codes"`;

    return (

        <IntroWrapper>
        <Container ref={props.innerRef}>
            <FadeIn delay={0.1} duration="0.3"><Name>Au Duong Tuan</Name></FadeIn>
            <IntroSentence>
            {introRender(introVerbiage, 0.2, messages, false)}
            </IntroSentence>
             <SlideIn delay="0.85" distance="20px"><ButtonLink to="/about" state={{fromHome: true}}>About me →</ButtonLink></SlideIn>
        </Container>
        </IntroWrapper>
    )
});
export default Intro;